export const createFormData = (
  data: Record<string, any> | Record<string, any>[],
  fileKey: string = 'File'
) => {
  const formData = new FormData();

  if (Array.isArray(data)) {
    data.forEach((item: Record<string, any>) => {
      if (item instanceof File) {
        formData.append(fileKey, item);
      } else {
        Object.entries(item).forEach((entry) => {
          if (
            entry[1] instanceof File ||
            (Array.isArray(entry[1]) && entry[1][0] instanceof File)
          ) {
            if (Array.isArray(entry[1])) {
              entry[1].forEach((file) => {
                formData.append(fileKey, file);
              });

              return;
            }

            formData.append(fileKey, entry[1]);
            return;
          }

          if (Array.isArray(entry[1])) {
            entry[1].forEach((itemData) => {
              formData.append(entry[0], itemData);
            });

            return;
          }

          formData.append(entry[0], entry[1]);
        });
      }
    });

    return formData;
  }

  Object.entries(data).forEach((entry) => {
    if (entry[1] instanceof File || (Array.isArray(entry[1]) && entry[1][0] instanceof File)) {
      if (Array.isArray(entry[1])) {
        entry[1].forEach((file) => {
          formData.append(fileKey, file);
        });

        return;
      }

      formData.append(fileKey, entry[1]);
      return;
    }

    if (Array.isArray(entry[1])) {
      entry[1].forEach((item) => {
        formData.append(entry[0], item);
      });

      return;
    }

    formData.append(entry[0], entry[1]);
  });

  return formData;
};
